import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useDosageFormList from "./hooks/useDosageFormList";

const DosageFormList = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  selectModeParamData = null,
}) => {
  const dosageFormListData = useDosageFormList(
    onSelect,
    hideModal,
    params,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={dosageFormListData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {dosageFormListData.screen_title} -{" "}
          <span className="heading-cod">{dosageFormListData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={dosageFormListData.formFields}
        dropdownValues={dosageFormListData.dropdownValues}
        paramsData={dosageFormListData.paramsData}
        updataParamData={dosageFormListData.updateParamData}
      />
      <ButtonsSection ctaButtons={dosageFormListData.ctaButtons} />
      <DisplayTable
        data={dosageFormListData.data}
        parmKey={dosageFormListData.parmKey}
        menuOptions={dosageFormListData.menuOptions}
        tableHeaders={dosageFormListData.columnDef}
        setRowData={dosageFormListData.setRowData}
        selectedPriceSchedules={dosageFormListData.selectedRows}
        setSelectedPriceSchedules={dosageFormListData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={dosageFormListData.first}
          rows={dosageFormListData.rows}
          totalRecords={dosageFormListData.totalRecords}
          currentPage={dosageFormListData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={dosageFormListData.onPageChange}
        />
      </div>
      {dosageFormListData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={dosageFormListData.isConfirmationModalOpen}
          onRequestClose={dosageFormListData.closeConfirmationModal}
          onBack={dosageFormListData.closeConfirmationModal}
          onSave={dosageFormListData.deleteDosageForm}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={dosageFormListData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default DosageFormList;
